export const supportedLanguages = {
  de: "German",
  en: "English",
};
export const supportedLanguagesUnprotected = {
  de: "German",
  en: "English",
};

export const supportedLanguagesConfig = supportedLanguages;
